import { NumericFormat } from "react-number-format"
import { Button, Tooltip, Typography } from "antd";
import { CheckOutlined } from '@ant-design/icons';
const { Text } = Typography;

export const AvailableBalance = ({ data }) => {
    return (<td>
        {data?.availableBalance && <NumericFormat value={data?.availableBalance} decimalScale={2} thousandSeparator={true} thousandsGroupStyle='lakh' displayType='text'></NumericFormat>}
    </td>
    )
}
export const TotalBalance = ({ data }) => {
    return (<td>
        {data?.balance && <NumericFormat value={data?.balance} decimalScale={2} thousandSeparator={true} thousandsGroupStyle='lakh' displayType='text'></NumericFormat>}
    </td>
    )
}

export const AddressHandler = ({ data, handleCopy, copied }) => {
    const walletAddress = data?.walletAddress;
  
    // Shortened display format
    const shortAddress = walletAddress
      ? `${walletAddress.substring(0, 8)}....${walletAddress.substring(walletAddress.length - 8)}`
      : '';
  
    return (
      <td style={{ paddingRight: 25 }}>
        {!walletAddress && (
          <div className="text-center text-whiteText"> -- </div>
        )}
  
        {walletAddress && copied !== data?.walletId && (
          <Text
            key={data?.walletId}
            className="text-whiteText flex justify-between"
            copyable={{
              text: walletAddress,
              onCopy: () => handleCopy(data?.walletId),
              tooltips: ['Copy', 'Copied']
            }}
          >
            <span>{shortAddress}</span>
          </Text>
        )}
  
        {walletAddress && copied === data?.walletId && (
          <Text className="text-whiteText flex justify-between" key={data?.walletId}>
            <span>{shortAddress}</span>
            <Tooltip title="Copied" open>
              <CheckOutlined style={{ marginLeft: 8, color: 'green' }} />
            </Tooltip>
          </Text>
        )}
      </td>
    );
  };
export const DepositHandler = ({ data, openModel }) => {
    return (
        <td>
            <Button className='cancel-btn py-1 px-2 h-9 !w-auto' onClick={openModel(data)}>Deposit</Button>
        </td>
    )
}